import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import HeroSection from '../components/pages/Home/HeroSection/HeroSection';
import PlatformSection from '../components/pages/Home/PlatformSection';
import InsightsSection from '../components/pages/Home/InsightsSection';
import ResourceSections from '../components/pages/Home/ResourceSections'
import ResultSection from '../components/pages/Home/ResultSection';
import TestimonialSection from '../components/pages/Home/TestimonialSection';
import CompanyNews from '../components/pages/Home/CompanyNews';
import VymoInsights from '../components/pages/Home/VymoInsights';
import LogoTicker from '../components/sections/LogoTicker';
import GetStartedSection from '../components/sections/GetStartedSection/GetStartedSection';

function IndexPage() {
  const seoProps = {
    title: "AI-Powered Insurance Distribution Management Platform",
    description: "Discover Vymo's meticulously crafted smart AI driven distribution management platform, tailored for insurers, MGAs, FMOs, IMOs, and insurance distributors worldwide.",
    slug: "us/",
  };

  return (
    <Layout seoProps={seoProps} mainClassName="home-page">
      <HeroSection />
      <LogoTicker />
      <PlatformSection />
      <InsightsSection />
      <ResourceSections />
      <ResultSection />
      <TestimonialSection />
      <CompanyNews />
      <VymoInsights />
      <GetStartedSection />
    </Layout>
  );
}

export default IndexPage;
